import React from 'react'
import PropTypes from 'prop-types'
import FontAwesome from 'react-fontawesome'

function ExternalLinkButton({ item, label, url, children }) {
  return (
    <a className="btn btn-xs btn-primary" href={url}>
      {label} <FontAwesome name="external-link" />
    </a>
  )
}

ExternalLinkButton.propTypes = {
  children: PropTypes.object,
  item: PropTypes.object.isRequired,
}

export default ExternalLinkButton
